import {stepsConfig} from "../config/steps";

export const STEP_LAYOUTS = {
    CUSTOM: "custom",
    SINGLE_SELECT: "single_select",
    MULTI_SELECT: "multi_select",
};

export const getSplashConfig = (stepId) => {
    const step = stepsConfig.steps[stepId];
    return step?.splash || null;
};

export const getStepById = (id) => {
    return stepsConfig.steps.findIndex((step) => step.id === id);
};

export const getStepId = (stepIndex) => {
    // If it's a splash screen, return a special format
    if (typeof stepIndex === 'string' && stepIndex.startsWith('splash_')) {
        const originalStep = parseInt(stepIndex.split('_')[1]);
        return `s_${stepsConfig.steps[originalStep]?.id}`;
    }
    return stepsConfig.steps[stepIndex]?.id || '';
};
